/**
 * 현장 업종 표시·건설 판정 — 화면의 소비처(목록 카드·검색·상세·현장 폼의 건설 단계)가 **이 한 자리에서** 파생한다.
 *
 * 규칙은 서버 짝 `apps/server/src/industries/site-industry.ts`(`siteIndustryFacts`)와 같다:
 * **KSIC(`site.industry`)가 있으면 KSIC가 정한다 · 없으면 레거시 자유 텍스트(`industryType`·`industrySubType`)로
 * 폴백한다.** 두 칸을 OR로 섞지 않는다. 레거시 칸은 읽기 전용이다 — 현장 폼은 KSIC picker만 쓴다(2026-10-30 대체).
 *
 * 표시 문구(`siteIndustryLabel`)는 사본을 두지 않고 shared 정본을 그대로 내보낸다 — 서버·admin과 한 벌이다
 * (KSIC가 대분류만이면 옛 세부를 병기하는 규칙이 그 함수에 있다 · 사용자 결정 2026-10-31).
 *
 * ⚠️ 이 모듈을 `lib/organizations`에 합치지 말 것 — 그 모듈을 `vi.mock`하는 spec이 많아 새 export가 생기면
 * 무관한 spec이 `No "X" export is defined on the mock`으로 죽는다.
 */
export { siteIndustryLabel } from '@safetyhub/shared';

export interface SiteIndustryInput {
  industryType?: string | null;
  industrySubType?: string | null;
  industry?: { code: string; name: string } | null;
}

const CONSTRUCTION_LEGACY = '건설업';

function trimmed(value: string | null | undefined): string | null {
  const t = value?.trim();
  return t ? t : null;
}

/** 건설업인가 — KSIC면 대분류 `F` · 없으면 레거시 「건설업」 */
export function isConstructionSiteIndustry(site: SiteIndustryInput | null | undefined): boolean {
  const code = trimmed(site?.industry?.code);
  if (site?.industry && code) return code.charAt(0).toUpperCase() === 'F';
  return trimmed(site?.industryType) === CONSTRUCTION_LEGACY;
}
